import React from 'react';

const PerformanceFeatures = () => {
  return (
    <div style={styles.pmFeaturesContainer}>
      {/* Section 1 - Image Left, Text Right */}
      <div style={styles.pmFeatureRow}>
        <div style={styles.pmImageSection}>
          <p style={styles.pmAnnotation}>Track goals and progress in real-time</p>
          <svg style={styles.pmArrow} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
            <path d="M 25 5 L 25 35 M 15 25 L 25 35 L 35 25" stroke="#ff6b6b" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <div style={styles.pmImageWrapper}>
            <img 
              src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80" 
              alt="Performance Dashboard"
              style={styles.pmImage}
            />
          </div>
        </div>
        <div style={styles.pmTextSection}>
          <div style={styles.pmIconCircle}>
            <svg style={styles.pmIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 11L12 14L22 4" stroke="#ff6b6b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 12V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H16" stroke="#ff6b6b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 style={styles.pmHeading}>
            <span style={styles.pmHeadingHighlight}>Set goals</span> that drive success
          </h2>
          <p style={styles.pmDescription}>
            Create clear, measurable objectives for every team member. 
            Track progress automatically and keep everyone aligned with 
            organizational goals, ensuring accountability at every level.
          </p>
        </div>
      </div>

      {/* Section 2 - Text Left, Image Right */}
      <div style={{...styles.pmFeatureRow, ...styles.pmFeatureRowReverse}}>
        <div style={styles.pmTextSection}>
          <div style={styles.pmIconCircle}>
            <svg style={styles.pmIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#00bcd4" strokeWidth="2"/>
              <path d="M12 6V12L16 14" stroke="#00bcd4" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h2 style={styles.pmHeading}>
            <span style={{...styles.pmHeadingHighlight, color: '#00bcd4'}}>Reviews made</span> simple
            <svg style={{...styles.pmUnderlineSvg, bottom: '0px'}} viewBox="0 0 200 8" xmlns="http://www.w3.org/2000/svg">
              <path d="M 0 4 Q 50 1, 100 4 T 200 4" stroke="#00bcd4" strokeWidth="6" fill="none" strokeLinecap="round"/>
            </svg>
          </h2>
          <p style={styles.pmDescription}>
            Streamline performance reviews with intuitive templates and 
            automated workflows. Schedule reviews, gather feedback, and 
            generate insights—all in one platform that saves time and 
            improves accuracy.
          </p>
        </div>
        <div style={styles.pmImageSection}>
          <p style={{...styles.pmAnnotation, ...styles.pmAnnotationBlue}}>
            Complete reviews in minutes
          </p>
          <svg style={{...styles.pmArrow, ...styles.pmArrowCurved}} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg">
            <path d="M 10 10 Q 50 5, 80 30 M 70 20 L 80 30 L 75 40" stroke="#00bcd4" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <div style={styles.pmImageWrapper}>
            <img 
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&q=80" 
              alt="Performance Review Interface"
              style={styles.pmImage}
            />
          </div>
        </div>
      </div>

      {/* Section 3 - Image Left, Text Right */}
      <div style={styles.pmFeatureRow}>
        <div style={styles.pmImageSection}>
          <p style={{...styles.pmAnnotation, ...styles.pmAnnotationPurple}}>
            Real-time feedback anytime
          </p>
          <svg style={styles.pmArrow} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
            <path d="M 25 5 L 25 35 M 15 25 L 25 35 L 35 25" stroke="#7c3aed" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <div style={styles.pmImageWrapper}>
            <img 
              src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&q=80" 
              alt="Feedback System"
              style={styles.pmImage}
            />
          </div>
        </div>
        <div style={styles.pmTextSection}>
          <div style={styles.pmIconCircle}>
            <svg style={styles.pmIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 11.5C21 16.75 16.75 21 11.5 21C6.25 21 2 16.75 2 11.5C2 6.25 6.25 2 11.5 2C16.75 2 21 6.25 21 11.5Z" stroke="#7c3aed" strokeWidth="2"/>
              <path d="M22 22L20 20" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h2 style={styles.pmHeading}>
            <span style={{...styles.pmHeadingHighlight, color: '#7c3aed'}}>Continuous feedback</span> culture
            <span style={{...styles.pmDots, color: '#7c3aed'}}>•••</span>
          </h2>
          <p style={styles.pmDescription}>
            Foster growth with ongoing feedback loops. Employees can give 
            and receive constructive feedback instantly, creating a culture 
            of continuous improvement without waiting for annual reviews.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pmFeaturesContainer: {
    width: '100%',
    padding: '80px 20px',
    backgroundColor: '#f9f9f9'
  },
  pmFeatureRow: {
    maxWidth: '1200px',
    margin: '0 auto 100px',
    display: 'flex',
    alignItems: 'center',
    gap: '60px',
    flexWrap: 'wrap'
  },
  pmFeatureRowReverse: {
    flexDirection: 'row-reverse'
  },
  pmImageSection: {
    flex: '1',
    minWidth: '300px',
    position: 'relative'
  },
  pmAnnotation: {
    fontFamily: '"Brush Script MT", cursive',
    fontSize: '22px',
    color: '#ff6b6b',
    fontStyle: 'italic',
    marginBottom: '10px',
    fontWeight: '400'
  },
  pmAnnotationBlue: {
    color: '#00bcd4'
  },
  pmAnnotationPurple: {
    color: '#7c3aed'
  },
  pmArrow: {
    width: '40px',
    height: '40px',
    marginBottom: '20px'
  },
  pmArrowCurved: {
    width: '80px'
  },
  pmImageWrapper: {
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 15px 50px rgba(0,0,0,0.15)',
    backgroundColor: '#fff'
  },
  pmImage: {
    width: '100%',
    height: 'auto',
    display: 'block'
  },
  pmTextSection: {
    flex: '1',
    minWidth: '300px',
    position: 'relative'
  },
  pmIconCircle: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
  },
  pmIcon: {
    width: '32px',
    height: '32px'
  },
  pmHeading: {
    fontSize: '42px',
    fontWeight: '700',
    color: '#1a1a1a',
    marginBottom: '20px',
    lineHeight: '1.3',
    fontStyle: 'italic',
    position: 'relative',
    display: 'inline-block',
    width: '100%'
  },
  pmHeadingHighlight: {
    color: '#ff6b6b',
    position: 'relative',
    display: 'inline-block'
  },
  pmUnderlineSvg: {
    position: 'absolute',
    bottom: '-5px',
    left: '0',
    width: '45%',
    height: '8px',
    zIndex: '1'
  },
  pmDots: {
    fontSize: '32px',
    marginLeft: '8px',
    position: 'relative',
    top: '-8px'
  },
  pmDescription: {
    fontSize: '18px',
    color: '#5f6368',
    lineHeight: '1.7',
    maxWidth: '500px'
  }
};

export default PerformanceFeatures;